<template>
  <v-container grid-list-md v-if="isRechargeEnabled">
    <v-card class="mx-auto" color="white">
      <v-card-text class="px-0">
        <h2 class="font-weight-light pb-3 text-center">Sistema de Recargas</h2>
      </v-card-text>
      <v-list three-line>
        <v-list-tile>
          <v-list-tile-content>
            <v-btn v-show="isLoad" v-bind:color="color" text >
              Processando...
              <v-progress-circular
                indeterminate
                color="white"
              ></v-progress-circular>
            </v-btn>
            <v-btn
              v-if="actived"
              v-bind:color="color"
              dark
              @click="enableNew"
            >
              Nova Recarga
            </v-btn>
            <v-card
              v-else
              class="mx-auto"
              color="warning"
              dark
            >
              <v-card-title>
                <span class="title font-weight-light">Entre em contato com o seu gerente comercial e comece a lucrar agora mesmo vendendo recargas com o PagRecargas! Mais um benefício para você.</span>
              </v-card-title>
            </v-card>
          </v-list-tile-content>
        </v-list-tile>
        
        <v-divider></v-divider>
        <br />
        
        <!-- Tabela integrada ao card -->
        <list />
      </v-list>
    </v-card>
    <modal-new />
  </v-container>
  <v-container grid-list-md text-xs-center class="background-billing" v-else>
    <v-layout row wrap class="align-bill">
      <v-card class="mx-auto" max-width="600" style="margin-top: 50px;">
        <v-card-text class="text-center">
          <v-icon size="64" color="grey lighten-1" class="mb-4">block</v-icon>
          <h2 class="headline mb-3">Sistema de Recargas Desabilitado</h2>
          <p class="body-1 grey--text text--darken-1">
            Esta funcionalidade não está disponível no momento. 
            Entre em contato com seu representante para mais informações.
          </p>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from '@/services/event-bus';
import moment from 'moment';

export default {
  name: 'recharge',
  created() {
    this.isloading = this.isLoad;
    this.$store.dispatch("system/fetchSystemConfiguration").then(() => {
      this.$store.dispatch("account/isRechargeEnabled");
    });
    this.$store.dispatch("account/getAccount");
  },
  mounted() {
  },
  computed: {
    ...mapGetters({
      actived: 'recharges/actived',
      activeNew: 'recharges/activeNew',
      isLoad: 'recharges/isLoad',
      color: 'account/color',
      isRechargeEnabled: "account/isRechargeEnabled",
    }),
  },
  components: {
    List: () => import('@/components/desktop/recharges/List.vue'),
    ModalNew: () => import('@/components/desktop/recharges/ModalNew.vue'),
  },
  methods: {
    enableNew() {
      this.$store.dispatch('recharges/activeNew', true);
    }
  },
  data: () => ({
    isloading: true,
  })
};
</script>

<style>
  .background-billing {
    background-color: #FFFFFF;
  }
  .align-bill {
    display: block;
    text-align: center;
  }
</style>
